import { ErrorPage } from '@/features/shared/components/ErrorPage'
import { withSimpleHeaderLayout } from '@/features/shared/components/Headers/Layouts/SimpleHeaderLayout'

function NotFound() {
  return <ErrorPage statusCode={404} />
}

export default withSimpleHeaderLayout(NotFound)
